export enum HeaderNavMenu {
  Back = 'back',
  Close = 'close',
  Favorite = 'favorite',
  Alarm = 'alarm',
  Reply = 'reply',
  More = 'more',
  Share = 'share',
  Save = 'save',
  Register = 'Register',
  Home = 'Home',
}

export enum WebViewScreen {
  Basic = 'Basic',
  Viewer = 'Viewer',
  Search = 'Search',
  Event = 'Event',
  Promotion = 'Promotion',
  PromotionDetail = 'PromotionDetail',
  Sign = 'Sign',
  EventDetail = 'EventDetail',
  Section = 'Section',
  Profile = 'Profile',
  PartnerProfile = 'PartnerProfile',
  ProfileAdd = 'ProfileAdd',
  ProfileEdit = 'ProfileEdit',
  PartnerProfileEdit = 'PartnerProfileEdit',
  FancyShareDetail = 'FancyShareDetail',
  RollingAdd = 'RollingAdd',
  RollingEdit = 'RollingEdit',
  RollingList = 'RollingList',
  RollingDetail = 'RollingDetail',
  Inbox = 'Inbox',
  Help = 'Help',
  MyActivityPoint = 'MyActivityPoint',
  MyAttendanceCheck = 'MyAttendanceCheck',
  MyContentAdd = 'MyContentAdd',
  MyContentEdit = 'MyContentEdit',
  MyContentDetail = 'MyContentDetail',
  MyContentSynopsis = 'MyContentSynopsis',
  MyEpisodeAdd = 'MyEpisodeAdd',
  MyEpisodeEdit = 'MyEpisodeEdit',
  ContentDetail = 'ContentDetail',
  ContentReply = 'ContentReply',
  ContentReReply = 'ContentReReply',
  EpisodeReply = 'EpisodeReply',
  EpisodeReReply = 'EpisodeReReply',
  DirittoStudio = 'DirittoStudio',
  PickAndChoo = 'PickAndChoo',
  Redirect = 'Redirect',
  ChatMessage = 'ChatMessage',
  RecentlyEdit = 'RecentlyEdit',
  FavoriteEdit = 'FavoriteEdit',
  SettingFavoriteCategory = 'SettingFavoriteCategory',
}

export const WebViewScreenPath: Record<WebViewScreen, RegExp> = {
  [WebViewScreen.Basic]: /^\/$/,

  [WebViewScreen.Sign]: /^sign$/, // /search

  [WebViewScreen.Search]: /^search$/, // /search
  [WebViewScreen.Inbox]: /^inbox$/, // /inbox
  [WebViewScreen.ChatMessage]: /^chats$/, // /chats
  [WebViewScreen.Help]: /^help/, // /help

  [WebViewScreen.FancyShareDetail]: /^fancy-shares\/\d+$/, // /fancy-shares/[fancyShareId]

  [WebViewScreen.RollingList]: /^rollings$/, // /rollings
  [WebViewScreen.RollingDetail]: /^rollings\/\d+$/, // /rollings/[rollingId]
  [WebViewScreen.RollingAdd]: /^rollings\/add$/, // /rollings/add
  [WebViewScreen.RollingEdit]: /^rollings\/\d+\/edit$/, // /rollings/[rollingId]/edit

  [WebViewScreen.Profile]: /^accounts\/profiles\/\d+$/, // /accounts/profiles/[profileId]
  [WebViewScreen.ProfileAdd]: /^accounts\/profiles\/add$/, // /accounts/profiles/add
  [WebViewScreen.ProfileEdit]: /^accounts\/profiles\/\d+\/edit$/, // /accounts/profiles/[profileId]/edit
  [WebViewScreen.PartnerProfile]: /^accounts\/partners\/\d+$/, // /accounts/partners/[partnerId]
  [WebViewScreen.PartnerProfileEdit]: /^accounts\/partners\/\d+\/edit$/, // /accounts/partners/[partnerId]/edit

  [WebViewScreen.Event]: /^events$/, // /events
  [WebViewScreen.EventDetail]: /^events\/\d+$/, // /events/[eventId]
  [WebViewScreen.Promotion]: /^promotions$/, // /promotions
  [WebViewScreen.PromotionDetail]: /^promotions\/.+$/, // /promotions/[promotionSlug]

  [WebViewScreen.MyActivityPoint]: /^activity-point$/, // /activity-point
  [WebViewScreen.MyAttendanceCheck]: /^attendance-check$/, // /attendance-check

  [WebViewScreen.MyContentAdd]: /^studio\/contents\/add$/, // /studio/contents/add
  [WebViewScreen.MyContentEdit]: /^studio\/contents\/\d+\/edit$/, // /studio/contents/[contentId]/edit
  [WebViewScreen.MyContentDetail]: /^studio\/contents\/\d+$/, // /studio/contents/[contentId]
  [WebViewScreen.MyContentSynopsis]: /^studio\/contents\/\d+\/synopsis$/, // /studio/contents/[contentId]/synopsis

  [WebViewScreen.MyEpisodeAdd]: /^studio\/contents\/\d+\/episodes\/add$/, // /studio/contents/[contentId]/episodes/add
  [WebViewScreen.MyEpisodeEdit]: /^studio\/contents\/\d+\/episodes\/\d+\/edit$/, // /studio/contents/[contentId]/episodes/[episodeId]/edit

  [WebViewScreen.Section]: /^sections\/.+$/, // /sections/[sectionSlug]

  [WebViewScreen.ContentDetail]: /^contents\/\d+$/, // /contents/[contentId]
  [WebViewScreen.Viewer]: /^contents\/\d+\/episodes\/\d+$/, // /contents/[contentId]/episodes/[episodeId]
  [WebViewScreen.ContentReply]: /^contents\/\d+\/replies$/, // /contents/[contentId]/replies
  [WebViewScreen.ContentReReply]: /^contents\/\d+\/replies\/\d+$/, // /contents/[contentId]/replies/[replyId]
  [WebViewScreen.EpisodeReply]: /^contents\/\d+\/episodes\/\d+\/replies$/, // /contents/[contentId]/episodes/[episodeId]/replies
  [WebViewScreen.EpisodeReReply]: /^contents\/\d+\/episodes\/\d+\/replies\/\d+$/, // /contents/[contentId]/episodes/[episodeId]/replies/[replyId]

  [WebViewScreen.DirittoStudio]: /^studio\/b$/, // /studio

  [WebViewScreen.PickAndChoo]: /^pick-and-choo$/, // /pick-and-choo
  [WebViewScreen.Redirect]: /^r\/.*$/, // /r/[url]

  [WebViewScreen.RecentlyEdit]: /^my\/recently\/edit$/, // /my/recently/edit
  [WebViewScreen.FavoriteEdit]: /^my\/favorites\/edit$/, // /my/favorites/edit

  [WebViewScreen.SettingFavoriteCategory]: /^accounts\/profiles\/setting\/favorite-category$/, // /accounts/profiles/setting/favorite-category
};

export const WebViewTitle: Record<WebViewScreen, string> = {
  [WebViewScreen.Viewer]: '',
  [WebViewScreen.Sign]: '',
  [WebViewScreen.Search]: '검색',
  [WebViewScreen.Event]: '이벤트',
  [WebViewScreen.EventDetail]: '',
  [WebViewScreen.Promotion]: '',
  [WebViewScreen.PromotionDetail]: '',
  [WebViewScreen.FancyShareDetail]: '',
  [WebViewScreen.Profile]: '',
  [WebViewScreen.ProfileAdd]: '새 프로필 만들기',
  [WebViewScreen.ProfileEdit]: '프로필 수정',
  [WebViewScreen.PartnerProfile]: '',
  [WebViewScreen.PartnerProfileEdit]: '파트너 프로필 수정',
  [WebViewScreen.MyActivityPoint]: '',
  [WebViewScreen.MyAttendanceCheck]: '출석체크',
  [WebViewScreen.MyContentAdd]: '내 작품 등록',
  [WebViewScreen.MyContentDetail]: '',
  [WebViewScreen.MyContentEdit]: '작품 정보 수정',
  [WebViewScreen.MyContentSynopsis]: '',
  [WebViewScreen.MyEpisodeAdd]: '',
  [WebViewScreen.MyEpisodeEdit]: '',
  [WebViewScreen.RollingList]: '',
  [WebViewScreen.RollingDetail]: '',
  [WebViewScreen.RollingAdd]: '',
  [WebViewScreen.RollingEdit]: '',
  [WebViewScreen.Inbox]: '알림',
  [WebViewScreen.Help]: '고객센터',
  [WebViewScreen.Section]: '',
  [WebViewScreen.ContentReply]: '',
  [WebViewScreen.ContentReReply]: '',
  [WebViewScreen.EpisodeReReply]: '',
  [WebViewScreen.EpisodeReply]: '',
  [WebViewScreen.ContentDetail]: '',
  [WebViewScreen.Basic]: '',
  [WebViewScreen.DirittoStudio]: '',
  [WebViewScreen.PickAndChoo]: '',
  [WebViewScreen.Redirect]: '',
  [WebViewScreen.ChatMessage]: '',
  [WebViewScreen.RecentlyEdit]: '편집',
  [WebViewScreen.FavoriteEdit]: '편집',
  [WebViewScreen.SettingFavoriteCategory]: '선호 장르 설정',
};
